import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '../ui/Button';
export function MidCTA() {
  return <section className="py-12 px-4 bg-salvia-light/30" data-id="element-142">
      <div className="max-w-4xl mx-auto text-center" data-id="element-143">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} data-id="element-144">
          <Button href="https://profelisto.com.ar/checkouts/cn/hWNCOg4zwoZqc0ny5ODqNWjq/es-ar?_r=AQABwGeMs0F4PDnJ0MDSl_7jeAJlCnmjpyzZmUWOGgZVlZo" className="text-lg md:text-xl py-4 px-8 shadow-lg" data-id="element-145">
            👉 BASTA DE IMPROVISAR — QUIERO MI YOGA 360
          </Button>
        </motion.div>
      </div>
    </section>;
}